import { BRAND_GREEN } from "../../theme/colors";

const STATUS_STYLES = {
  occupied: {
    color: BRAND_GREEN,
    backgroundColor: "rgba(100, 131, 21, 0.12)",
    borderColor: "rgba(100, 131, 21, 0.28)",
  },
  vacant: {
    color: "#B42318",
    backgroundColor: "#FEE4E2",
    borderColor: "#FECDCA",
  },
  "under construction": {
    color: "#B54708",
    backgroundColor: "#FEF0C7",
    borderColor: "#FEDF89",
  },
};

export function getPropertyStatusSx(status) {
  return STATUS_STYLES[String(status || "Occupied").trim().toLowerCase()] || STATUS_STYLES.occupied;
}
